import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/services/periodontal-treatment/ImportanceOfGoodOralHealth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/services/periodontal-treatment/NonSurgicalPeriodontalTreatment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/tools/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/tools/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/tools/RelatedTopics.tsx");
